export function formatAsTitle(string) {
  string = string.replaceAll('_', ' ');
  return string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
}
